function Footer() {
  return (
    <footer className="text-center py-6 px-4 text-gray-200 text-sm border-t border-gray-700/50 bg-gray-800">
      © 2025 Huda Hussin :D | Built with React.js and TailwindCSS
    </footer>
  );
}

export default Footer;